import * as React from "react";
import { pushSimpleEvent } from "@nju/data-layer";
import { Button, Heading, Separator, Text } from "@nju/ui";

interface IChooseNewNumberNoResultsProps {
  onSubmit: () => void;
}

export function ChooseNewNumberNoResults({
  onSubmit,
}: IChooseNewNumberNoResultsProps) {
  React.useEffect(() => {
    pushSimpleEvent({
      event: "error_number_carousel",
      eventName: "NumbersNotAvailable",
    });
  }, []);

  return (
    <div>
      <Heading
        className="flex justify-center font-bold mt-2 mb-2 from-tablet:mb-6"
        font="ttfirs"
        tone="neutral"
        variant="h2"
      >
        brak dostępnych numerów
      </Heading>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <img
          alt="calculator-error"
          className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
          src="/images/calculator-error.svg"
        />
      </div>
      <Separator size="s" tone="invisible" />
      <Text
        align="center"
        display="block"
        size={{
          "@fromDesktop": "l",
        }}
      >
        System nie odpowiada, dlatego nie możemy wyświetlić Ci listy dostępnych
        numerów.
      </Text>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center only-mobile:flex-col">
        <Button onPress={onSubmit} size={{ "@onlyMobile": "s" }}>
          spróbuj ponownie
        </Button>
      </div>
    </div>
  );
}
